import { Article, ArticleListResource } from "../generated-api";
import { ArticlesListRequestType } from "./types";
import ApiClient from "@/api/ampm-world";

export class ApiActual {
  static async getActual(lang: string, params: ArticlesListRequestType): Promise<ArticleListResource> {
    return ApiClient.get(`/${lang}/articles`, {
      ...params,
      page_number: params.pageNumber,
      page_size: params.pageSize,
    });
  }

  static async getActualYears(lang: string): Promise<number[]> {
    return ApiClient.get(`/${lang}/years`);
  }

  static async getDetailActual(lang: string, id: number): Promise<Article> {
    return ApiClient.get(`/${lang}/article/${id}`);
  }
}
